import { render, staticRenderFns } from "./NextBtn.vue?vue&type=template&id=22088466&"
import script from "./NextBtn.vue?vue&type=script&lang=js&"
export * from "./NextBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xampp\\htdocs\\lifeline-donation-pro\\wp-content\\plugins\\lifeline-donation-pro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22088466')) {
      api.createRecord('22088466', component.options)
    } else {
      api.reload('22088466', component.options)
    }
    module.hot.accept("./NextBtn.vue?vue&type=template&id=22088466&", function () {
      api.rerender('22088466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/NextBtn.vue"
export default component.exports